import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="bg-cream py-10 px-6 md:py-16" data-id="element-135">
      <div className="max-w-4xl mx-auto text-center" data-id="element-136">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="font-playfair text-3xl md:text-5xl lg:text-6xl text-charcoal mb-8 leading-tight" data-id="element-137">
          POUR LA MAMAN SOLO QUI EN A ASSEZ DE SURVIVRE
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="font-playfair italic text-xl md:text-2xl text-burgundy mb-8" data-id="element-138">
          "Et si le pire jour de ta vie était en réalité le premier jour de ta
          vraie vie ?"
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mb-8" data-id="element-139">
          <img src="https://cdn.magicpatterns.com/uploads/4f8oP9vupbaJBysmD7wbRq/COVER.png" alt="RE-NAISSANCE Ebook Cover" className="mx-auto w-64 md:w-80 shadow-2xl rounded-lg" data-id="element-140" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="font-playfair text-2xl md:text-3xl text-charcoal mb-8" data-id="element-141">
          Comment des milliers de mamans solo ont retrouvé leur identité, leur
          énergie et leur joie de vivre en seulement 30 jours...
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="space-y-3 mb-8 text-lg" data-id="element-142">
          <p data-id="element-143">
            <span className="text-burgundy font-bold mr-2" data-id="element-144">✗</span>Sans
            thérapeute à 200$/heure
          </p>
          <p data-id="element-145">
            <span className="text-burgundy font-bold mr-2" data-id="element-146">✗</span>Sans chercher
            un homme
          </p>
          <p data-id="element-147">
            <span className="text-burgundy font-bold mr-2" data-id="element-148">✗</span>Sans
            sacrifier une minute de plus
          </p>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="font-playfair italic text-xl text-charcoal mb-8" data-id="element-149">
          "Même si tu te sens complètement vide, épuisée et perdue ce soir."
        </motion.p>

        <motion.button initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.7
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="bg-burgundy text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-opacity-90 transition-all shadow-lg whitespace-nowrap" onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-150">
          Je Commence Ma Renaissance →
        </motion.button>
      </div>
    </section>;
}